import { NgModule } from "@angular/core";
import { HomeComponent } from './home/home.component';
import { UlazniDokumentDobavljacaTabsComponent } from './ulazni-dokument-dobavljaca/ulazni-dokument-dobavljaca-tabs.component';
import { UlazniDokumentDobavljacaTabUpdateComponent } from './ulazni-dokument-dobavljaca/ulazni-dokument-dobavljaca-tab-update.component';
import { ModalContainerService, ModalService } from "yt-ng-framework";
import { EfaktureRoutingModule } from "./efakture-routing.module";
import { LookupsModule } from "../lookups/lookups.module";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { TranslateModule } from "@ngx-translate/core";
import { EfaktureComponent } from "./efakture.component";
import { FilterWithKomitentComponent } from './_filters/filter-with-komitent.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { ProveraPosiljaocaComponentComponent } from './ulazni-dokument-dobavljaca/provera-posiljaoca/provera-posiljaoca-component.component';
import { SefAccessGuard } from "./guards/sef-access.guard";
@NgModule({
    imports: [
        EfaktureRoutingModule,
        LookupsModule,
        NgbModule,
        TranslateModule
        , PdfViewerModule
    ],
    declarations: [
        HomeComponent, 
        EfaktureComponent,
        UlazniDokumentDobavljacaTabsComponent, 
        UlazniDokumentDobavljacaTabUpdateComponent,
        FilterWithKomitentComponent,
        ProveraPosiljaocaComponentComponent
    ],
    exports: [
        UlazniDokumentDobavljacaTabsComponent, 
        UlazniDokumentDobavljacaTabUpdateComponent
    ],
    // entryComponents: [
    //     FilterWithKomitentComponent
    // ],
    providers: [
        ModalContainerService,
        ModalService,
        SefAccessGuard
    ]
})
export class EfaktureModule {}
